export default __webpack_public_path__ + "static/media/genres-manager.80553eae.svg";